/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated';
import { addDependencies } from './dependenciesAdd.generated';
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { atanDependencies } from './dependenciesAtan.generated';
import { bignumberDependencies } from './dependenciesBignumber.generated';
import { cosDependencies } from './dependenciesCos.generated';
import { equalDependencies } from './dependenciesEqual.generated';
import { invDependencies } from './dependenciesInv.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated';
import { sinDependencies } from './dependenciesSin.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createEigs } from '../../factoriesAny.js';
export var eigsDependencies = {
  absDependencies: absDependencies,
  addDependencies: addDependencies,
  addScalarDependencies: addScalarDependencies,
  atanDependencies: atanDependencies,
  bignumberDependencies: bignumberDependencies,
  cosDependencies: cosDependencies,
  equalDependencies: equalDependencies,
  invDependencies: invDependencies,
  matrixDependencies: matrixDependencies,
  multiplyDependencies: multiplyDependencies,
  multiplyScalarDependencies: multiplyScalarDependencies,
  sinDependencies: sinDependencies,
  subtractDependencies: subtractDependencies,
  typedDependencies: typedDependencies,
  createEigs: createEigs
};